export default "__VITE_ASSET__D3ZasIB7__"